import React from "react";
import { FcAbout } from "react-icons/fc";

const AboutMe = ({ theme }) => {
  return (
    <div
      className={`py-20 group flex flex-col gap-5 border-b-[1px] ${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      }`}
    >
      <h3
        className={`text-[32px] flex flex-row justify-center lgl:justify-start items-center gap-4 text-center lgl:text-left ${
          theme === "dark" ? "text-darkTextColor" : "text-lightTextColor"
        } font-bold`}
      >
        About me
        <span>
          <FcAbout className="text-4xl group-hover:animate-pulse" />
        </span>
      </h3>
      <p
        className={`text-xl lgl:text-2xl text-justify tracking-tight lgl:tracking-tight ${
          theme === "dark"
            ? "text-darkTextDesignColor font-light"
            : "text-bgColor font-normal"
        }`}
      >
        I am a Software Engineer with 6+ years of experience in React. I have a
        strong foundation in front-end & back-end development and am skilled in
        creating user-friendly and responsive web applications using React and
        its ecosystem. I have experience working on a variety of projects,
        including building and maintaining single page applications, integrating
        with REST APIs, and implementing responsive design principles. I am also
        proficient in using tools such as Webpack, Turbopack, npm, yarn, pnpm
        and Git for development and deployment. In addition to my technical
        skills, I am a strong communicator and team player. I am able to work
        effectively with cross-functional teams and am comfortable taking on new
        challenges and learning new technologies as needed.
      </p>
      <p
        className={`text-xl lgl:text-2xl text-justify tracking-tight lgl:tracking-tight font-light ${
          theme === "dark"
            ? "text-darkTextDesignColor font-light"
            : "text-bgColor font-normal"
        }`}
      >
        I am always looking to improve my skills and stay up-to-date with the
        latest best practices in web development. I am excited to continue
        growing as a developer and making meaningful contributions to projects
        and teams.
      </p>
    </div>
  );
};

export default AboutMe;
